import { OptionDto } from './quiz.dto';

export class Option {
    readonly id: string;
    readonly text: string;
    readonly order: number;

    constructor(data: OptionDto) {
        this.id = data.id ?? '';
        this.text = data.text ?? '';
        this.order = data.order ?? 0;
    }
}
